import React from "react";
import "./UserAvatar.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AvatarDef } from "../models/messages";
import { AVATAR_ICONS, AVATAR_COLOURS } from "../constants/avatars";

interface Props {
  avatarDef: AvatarDef;
}

export default function UserAvatar(props: Props) {
  const { avatarDef } = props;

  return (
    <div className="c-user-avatar d-flex justify-content-center align-items-center text-center">
      <FontAwesomeIcon
        icon={AVATAR_ICONS[avatarDef.icon_id % AVATAR_ICONS.length]}
        color={AVATAR_COLOURS[avatarDef.colour_id % AVATAR_COLOURS.length]}
        className="c-user-avatar__avatar"
      />
    </div>
  );
}
